const getters = {
    userName: state => state.user.userName,
    abpConfig: state => state.app.abpConfig,
    user: state => state.user,
    name: state => state.user.name,
    active:state=> state.app.active,
    loading:state=> state.app.loading,
    userinfo:state=> state.userinfo,
    allow:state=>state.user.allow,
    id:state=>state.user.id,
    backend:state=>state.user.backend,
    auth:state=>state.user.auth,
    language:state=>state.user.language
}
export default getters
